export enum ETipoCodigo {
    CodigoBarras = 1,
    Personalizado = 2,
    CodigoBalanca = 3
}
